import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('DocumentModelDA', DocumentModelDA);

    DocumentModelDA.$inject = ['Restangular', 'CONF', 'DocumentModelDto', 'ControlSet'];

    /**
     * Class permettant al manipulation des template de facture
     */

    /* @ngInject */
    function DocumentModelDA(Restangular, CONF, DocumentModelDto, ControlSet) {
        var baseUrl = CONF.apiBaseUrl + '/v1/document-models';

        var exports = {
            getDictionary: getDictionary,
            getDictionaryAttributs: getDictionaryAttributs,
            getDocumentModel: getDocumentModel,
            saveDocumentModel: saveDocumentModel,
            getControlSets: getControlSets,
            getModelByCategoryAndType: getModelByCategoryAndType,
            getModelByCategoryAndTypeAndParentKey: getModelByCategoryAndTypeAndParentKey,
            getControlSetByClientKeyAndType: getControlSetByClientKeyAndType,
        };

        return exports;

        ////////////////

        /**
         * Récupère tous les attributs du model étendu pour un donneur d'ordre désigné
         * ce ne sont pas uniquement les attributs qui vont apparaitre à l'écran,
         * mais ceux à l'écran + ceux qui pourront être rajoutés pour ce DO
         *
         * @param {string} principalEid - Identifiant (EID) du DO
         * @returns DocumentModel comportant la liste des attributs du model étendu
         *
         */
        function getDictionary(principalEid, functionalType) {
            return Restangular.one(baseUrl, principalEid)
                .oneUrl(functionalType)
                .oneUrl('dictionary')
                .get()
                .then(function (data) {
                    return new DocumentModelDto(data).documentModel.attributes;
                });
        }

        /**
         *  Permet de récupérer les attributs non multi-occurrence du dictionnaire du DO
         *  sinon du dictionnaire standard.
         *
         * @param {string} principalEid - Identifiant (EID) du DO
         * @returns DocumentModel comportant la liste des attributs du model étendu
         *
         */
        function getDictionaryAttributs(principalEid, functionalType) {
            return Restangular.one(baseUrl, principalEid)
                .oneUrl(functionalType)
                .oneUrl('filtred-attributes')
                .get()
                .then(function (data) {
                    return data;
                });
        }

        /**
         * Récupère les attributs du model à afficher pour le spécifique
         *
         * @param {string} principalEid - Identifiant du DO
         * @returns DocumentModel comportant la liste des attributs du model spécifique
         */
        function getDocumentModel(principalEid, functionalType) {
            return Restangular.one(baseUrl, principalEid)
                .oneUrl(functionalType)
                .oneUrl('model')
                .get()
                .then(function (data) {
                    return new DocumentModelDto(data);
                });
        }

        /**
         * Récupère les attributs du model à afficher pour le spécifique
         *
         * @param {string} principalEid - Identifiant du DO
         * @param modelCategory categorie du modele document.
         * @param modelType Le type de document.
         * @returns la liste de nom des modeles spécifiques
         */
        function getModelByCategoryAndType(principalEid, modelCategory, modelType) {
            return Restangular.one(baseUrl, principalEid)
                .oneUrl(modelCategory)
                .oneUrl(modelType)
                .oneUrl('names')
                .get()
                .then(data => data);
        }

        /**
         * Récupère les attributs du model à afficher pour le spécifique en applicant le filtre sur le modèle parent
         *
         * @param {string} principalEid - Identifiant du DO
         * @param modelCategory categorie du modele document.
         * @param {string} parentKey parentKey du modele document.
         * @param modelType Le type de document.
         * @returns la liste de nom des modeles spécifiques
         */
        function getModelByCategoryAndTypeAndParentKey(principalEid, modelCategory, modelType, parentKey) {
            return Restangular.one(baseUrl, principalEid)
                .oneUrl(modelCategory)
                .oneUrl(modelType)
                .oneUrl(parentKey)
                .oneUrl('names')
                .get()
                .then(data => data);
        }

        /**
         * Récupère les control-sets par un Type
         *
         * @param {string} principalEid Identifiant du DO
         * @param {string} controlSetType Le type de control-set
         * @returns {*} la liste de nom des control-sets
         */
        function getControlSetByClientKeyAndType(principalEid, controlSetType) {
            return Restangular.one(baseUrl, principalEid)
                .oneUrl('control-set')
                .oneUrl(controlSetType)
                .get()
                .then(data => data);
        }

        /**
         * Enregistrement du model spécifique
         *
         * @param {string} principalEid ou communityEid - Identifiant (EID) du DO ou community
         * @param {DocumentModelParams} DocumentModelParams - Donnée de la facture à enregistrer
         */
        function saveDocumentModel(principalEid, documentModel, functionalType) {
            return Restangular.one(baseUrl, principalEid)
                .oneUrl(functionalType)
                .all('model')
                .post(documentModel)
                .then(function (data) {
                    return new DocumentModelDto(data);
                });
        }

        /**
         * Récupère les set de controles.
         */
        function getControlSets(principalEid, functionalType) {
            return Restangular.one(baseUrl, principalEid)
                .oneUrl(functionalType)
                .oneUrl('control-sets')
                .get()
                .then(function (data) {
                    return _.map(data.controlSets, function (controlSet) {
                        return new ControlSet(controlSet);
                    });
                });
        }
    }
})();
